import React from 'react';
import {getOverrides, MuiMarkdown} from "mui-markdown";
import {useTranslation} from "react-i18next";
import MarkdownLink from "./components/markdownLink";
import ImageLoader from "../imageLoader/ImageLoader";

function CustomMarkdown({children}) {
    const {t} = useTranslation();

    return (
        <div>
            <MuiMarkdown overrides={{
                ...getOverrides(),
                muimarkdown: {
                    component: CustomMarkdown
                },
                imgLoader: {
                    component: ImageLoader
                },
                a: {
                    component: MarkdownLink
                }
            }}>{t(children[0])}</MuiMarkdown>
        </div>
    );
}

export default CustomMarkdown;
